import { isEqual } from 'lodash';

import type { TreeItem } from '@revelio/iso-utility';

import type { ReportBuilderDeliverable } from '../../report-builder.model';
import { getReport, reportBuilderStore } from '../../report-builder.repository';
import type { ReportEntityConfig } from './utils';

export const updateReportEntitySelections = ({
  reportId,
  reportEntity,
  selections,
}: {
  reportId: ReportBuilderDeliverable['id'];
  reportEntity: string;
  selections: Record<string, TreeItem<string>>;
}) => {
  // Fetch the current report to avoid unnecessary updates when the selections are unchanged
  const currentReport = getReport(reportId);
  if (currentReport) {
    const currentSelections = currentReport.selections?.[reportEntity];
    if (isEqual(currentSelections, selections)) {
      // No change in selections – skip store update
      return;
    }
  }

  reportBuilderStore.actions.updateReport(reportId, (report) => ({
    ...report,
    selections: {
      ...report.selections,
      [reportEntity]: selections,
    },
  }));
};

/**
 * Checks if a column matches the columnId. Useful when working with hidden columns.
 */
export const isColumnId = (
  columnId: string,
  column: {
    id?: string;
    label?: string;
  }
) => {
  const id = column.id?.toLowerCase() ?? '';
  const label = column.label?.toLowerCase() ?? '';
  return id.includes(columnId) || label.includes(columnId);
};

/**
 * Finds a column with the given id for report entity config.
 */
export const findColumnWithId = (
  entityConfigs: ReportEntityConfig | null,
  id: string
) => {
  return entityConfigs?.columns?.find((c) => isColumnId(id, c));
};
